"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsiteFastTagError = void 0;
var WebsiteFastTagError;
(function (WebsiteFastTagError) {
    WebsiteFastTagError["DUPLICATE_SELLER_ID"] = "DUPLICATE_SELLER_ID";
    WebsiteFastTagError["INVALID_FT_SETTING"] = "INVALID_FAST_TAG_SETTING";
    WebsiteFastTagError["NOT_FOUND"] = "NOT_FOUND";
    WebsiteFastTagError["MISSING_SELLER_ID"] = "MISSING_SELLER_ID";
    WebsiteFastTagError["MISSING_SHIPPING_COST"] = "MISSING_SHIPPING_COST";
    WebsiteFastTagError["REFRESH_ALREADY_IN_PROGRESS"] = "REFRESH_ALREADY_IN_PROGRESS";
    WebsiteFastTagError["SHIPPING_RATE_OFFER_NOT_FOUND"] = "SHIPPING_RATE_OFFER_NOT_FOUND";
})(WebsiteFastTagError = exports.WebsiteFastTagError || (exports.WebsiteFastTagError = {}));
//# sourceMappingURL=WebsiteFastTagError.js.map